import React from "react";
import { HiringData } from "./CalculatorForm";

interface HiringSummarySectionProps {
  hiringData: {
    tech: HiringData;
    gtm: HiringData;
    gna: HiringData;
    exec: HiringData;
  };
}

export const HiringSummarySection = ({ hiringData }: HiringSummarySectionProps) => {
  const calculateTotals = () => {
    return Object.values(hiringData).reduce(
      (acc, data) => ({
        startingHeadcount: acc.startingHeadcount + data.startingHeadcount,
        incrementalHires: acc.incrementalHires + data.incrementalHires,
        endingHeadcount: acc.endingHeadcount + data.endingHeadcount,
        backfillHires: acc.backfillHires + data.backfillHires,
        plannedGrossHires: acc.plannedGrossHires + data.plannedGrossHires,
      }),
      {
        startingHeadcount: 0,
        incrementalHires: 0,
        endingHeadcount: 0,
        backfillHires: 0,
        plannedGrossHires: 0,
      }
    );
  };

  const calculateAverageAttrition = () => {
    const teams = Object.values(hiringData);
    const totalAttrition = teams.reduce((sum, data) => sum + data.backfillPercentage, 0);
    return Math.round(totalAttrition / teams.length);
  };

  const totals = calculateTotals();
  const averageAttrition = calculateAverageAttrition();
  const growthPercentage =
    totals.startingHeadcount === 0
      ? 0
      : Math.round(
          ((totals.endingHeadcount - totals.startingHeadcount) /
            totals.startingHeadcount) *
            100
        );

  return (
    <div className="border-t-2 mt-4 pt-4 overflow-x-auto -mx-4 px-4 md:overflow-visible md:px-0 md:mx-0">
      <div className="grid grid-cols-7 gap-4 items-center min-w-[800px] md:min-w-0">
        <div className="font-semibold">Total</div>
        <div className="font-semibold">{totals.startingHeadcount}</div>
        <div className="font-semibold">{totals.incrementalHires}</div>
        <div className="font-semibold flex items-center gap-2">
          {totals.endingHeadcount}
          <span className="text-sm text-gray-500">({growthPercentage}%)</span>
        </div>
        <div className="font-semibold">{averageAttrition}%</div>
        <div className="font-semibold">{totals.backfillHires}</div>
        <div className="font-semibold">{totals.plannedGrossHires}</div>
      </div>
    </div>
  );
};